import ClientNotificationInterface from '../../interfaces/client/Notification'

import notificationTypes from '../../config/notificationTypes'

import generateUniqueId from '../generateUniqueId'

const defaultType = notificationTypes.error

/**
 * Create notification based on possible server error responses.
 * These responses can include strings but also (empty) objects.
 * To simplify the error handling we'll just assume that every object
 * we get as a server error is a generic server error.
 *
 * @param message {Object | string}
 * @param type {String}
 */
const buildServerNotification = (
  message: any,
  type?: string
): ClientNotificationInterface => {
  const errorMessage =
    typeof message === 'string' ? message : 'generic_server_error'

  return {
    id: generateUniqueId(),
    type: type || defaultType,
    message: errorMessage,
    code: `[${errorMessage}]`,
    isGlobal: true,
  }
}

export default buildServerNotification
